import Dropdown from "../../Components/Dropdown/Dropdown";
import classesCss from './Dropdowns.module.css';

const Dropdowns = ({dropdowns, links, menuHeight, headerHeight, fontSize}) => {
    return (
        <div className={"flex justify-center items-center ml-5"}>
            {
                dropdowns.map(({items, sub}, index) => <Dropdown headerHeight={headerHeight}
                                                                 fontSize={fontSize}
                                                                 menuHeight={menuHeight}
                                                                 items={items}
                                                                 sub={sub} key={index}/>)
            }
            {
                links.map(({url, text}, index) => <a href={url} style={{
                    padding: headerHeight,
                    fontSize,
                }} className={classesCss.link} key={index}>
                        {text.toUpperCase()}
                    </a>)
            }
        </div>
    );
};

export default Dropdowns;
